export const ORDER_FAILURE_MESSAGE_KEY = 'orderFailureMessage';

/**
 * used by psp specific giftcard components in the
 * integrations directory.
 */
export const CARD_ALIAS_TRANSLATION_ID = 'gift';
